import { combineReducers } from 'redux';

import my from './my';
// import acquiring from './acquiring';
// import replenish from './replenish';
import tariffs from './tariffs';
import paymentMethods from './paymentMethods';


export default combineReducers({
  my,
  // acquiring,
  // replenish,
  tariffs,
  paymentMethods,
});
